import { createContext } from 'react';

const BalanceCreditoContext = createContext({
  balanceCreditoData: [],
  setBalanceCreditoData: () => {},
});

export default BalanceCreditoContext;